// @flow

import { logger } from '../../common'

type RequestParams = {
  url: string,
  processResponse: Function,
  data: Object
}

export function urlEncodeData (data: Object): string {
  const urlEncodedDataPairs = []
  for (const name in data) {
    urlEncodedDataPairs.push(encodeURIComponent(name) + '=' + encodeURIComponent(data[name]))
  }
  return urlEncodedDataPairs.join('&').replace(/%20/g, '+')
}

export function request (requestParams: RequestParams) {
  const xhr = new XMLHttpRequest()
  xhr.onreadystatechange = () => {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      logger.info('' + xhr.status)
      logger.info(xhr.getResponseHeader('content-type'))
      requestParams.processResponse(xhr)
    }
  }
  xhr.open('POST', requestParams.url)
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
  xhr.send(urlEncodeData(requestParams.data))
}

export function jsonRequest (requestParams: RequestParams) {
  const xhr = new XMLHttpRequest()
  xhr.onreadystatechange = () => {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      requestParams.processResponse(xhr)
    }
  }
  xhr.open('POST', requestParams.url)
  xhr.setRequestHeader('Content-Type', 'application/json')
  xhr.send(JSON.stringify(requestParams.data))
}
